import { useContext } from 'react';
import { GeofenceTooltipGetterContext } from '../../layers/geofence-layer-group/GeofenceTooltipContextProvider';
import GeofenceTooltip from './GeofenceTooltip';

export function GeofenceTooltipController() {
  // Get the properties of the geofence that the mouse is currently over.
  const properties = useContext(GeofenceTooltipGetterContext);

  return <GeofenceTooltip properties={properties} />;
}

export default GeofenceTooltipController;
